import { expiryLabel, expiryStatus } from "../lib/format";

const STYLES = {
  expired: "border-danger/50 bg-danger/10 text-danger",
  soon: "border-signal/50 bg-signal/10 text-signal",
  ok: "border-line text-ink-3",
  unknown: "border-line text-ink-3",
} as const;

/** Only renders when there is something to say — an unset date is not news. */
export function ExpiryPill({
  label,
  date,
  alwaysShow = false,
}: {
  label: string;
  date: string | null;
  alwaysShow?: boolean;
}) {
  const status = expiryStatus(date);
  if (!alwaysShow && (status === "ok" || status === "unknown")) return null;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded border px-2 py-0.5 font-mono text-[11px] ${STYLES[status]}`}
    >
      <span className="uppercase">{label}</span>
      <span className="opacity-80">{expiryLabel(date)}</span>
    </span>
  );
}
